import axios from "axios"
import { env } from '../constants'


/* GET HISTORY */
export const history = (token, page = 1) => {
    const uri = `${env.cpoint}/vip-poker/history/list?page=${page}&game=RVP`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}